export type { ResourceDescriptor } from './wrm-require';
export { fetchWrmResourceDescriptors } from './wrm-require';
